import { render, staticRenderFns } from "./FlashcardDeckListItems.vue?vue&type=template&id=713efdd0&scoped=true&"
import script from "./FlashcardDeckListItems.vue?vue&type=script&lang=js&"
export * from "./FlashcardDeckListItems.vue?vue&type=script&lang=js&"
import style0 from "./FlashcardDeckListItems.vue?vue&type=style&index=0&id=713efdd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713efdd0",
  null
  
)

export default component.exports